import { clsx } from 'clsx'
import { type FC } from 'react'

import { useGlobalConfigContext } from '../../global-config'
import { ProductPicture } from '../../product'
import { assetUrlGetPrefixed } from '../../url-handling'

type OrderImageItemProps = {
  alt: string
  'data-qa-id'?: string
  isERx?: boolean
  src: string | undefined
}

export const OrderImageItem: FC<OrderImageItemProps> = ({
  alt,
  'data-qa-id': dataQaId,
  isERx,
  src,
}) => {
  const { assetsPrefix } = useGlobalConfigContext()
  const imageSrc = isERx
    ? assetUrlGetPrefixed(
        assetsPrefix,
        '/images/accountpage-e-prescription.svg',
      )
    : src

  return (
    <li
      className={clsx(
        'relative size-16 shrink-0 grow-0 rounded bg-light-primary-medium',
        isERx && 'flex p-1',
      )}
      data-qa-id={dataQaId}
    >
      <ProductPicture
        imageProps={{
          alt,
          className: 'object-contain rounded',
          fill: true,
          src: imageSrc,
        }}
      />
    </li>
  )
}
